import { render, staticRenderFns } from "./MenuBoxSelectedInfo.vue?vue&type=template&id=94d1b0a2&scoped=true&"
import script from "./MenuBoxSelectedInfo.vue?vue&type=script&lang=js&"
export * from "./MenuBoxSelectedInfo.vue?vue&type=script&lang=js&"
import style0 from "./MenuBoxSelectedInfo.vue?vue&type=style&index=0&id=94d1b0a2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d1b0a2",
  null
  
)

export default component.exports